<form class="forgot-password-container" [formGroup]="resetPasswordForm">
  <div class="icon-close" (click)="closeModal()">
    <i class="icon-X"></i>
  </div>
  <h3 class="text-llg">{{ 'Enter your new'|translate }} <br> {{ 'password'|translate }}</h3>
  <app-input
    [placeholder]="'Enter password'|translate"
    [title]="'New password'|translate"
    [required]="true"
    [isSubmitRequired]="true"
    [isSubmitted]="isSubmitted"
    type="password"
    formControlName="password"
    class="mb-24"
  ></app-input>
  <app-input
    [placeholder]="'Re-enter the password' | translate"
    [title]="'Confirm new password' | translate"
    [required]="true"
    [isSubmitRequired]="true"
    [isSubmitted]="isSubmitted"
    type="password"
    formControlName="confirmPassword"
  ></app-input>
  <app-password-validation [passwordRequirements]="passwordRequirements"></app-password-validation>
  <div class="verify-btn">
    <app-button
      ariaLabel="Submit"
      [buttonStyleType]="BUTTON_TYPES.PRIMARY_0"
      [disabled]="!isSubmitAvailable"
      (click)="submitPassword()"
    >{{ 'Submit' |translate }}
    </app-button>
  </div>
</form>
